module.exports = __webpack_public_path__ + "img/realisationCvtech.325c2cc6.jpg";